import React from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'

import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

import { Application } from 'components/JobBoardDetails'
import { ResumeViewRedesigned } from 'components/ResumeView'
import { TopBarRedesigned, AdditionalActionsIconType } from "components/TopBarRedesigned";
import { openExternalUrl, RESUME_FILE_ALLOWED_HOSTS, validateResumeFileUrl } from 'utils/nativeApp';

declare let window: any

const PageWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	background-color: #fff;
	overflow: auto;
	position: relative;
	min-height: 100vh;
`;

export default function DentistResumeViewPage() {
	const history = useHistory()

	const application = usePersistedState<Application>({
		entityName: entities.dentistCandidateApplication,
	})[0]

	const hireResumeUrl = application?.hireResumeUrl;

	const onResumeDownload = () => {
		if (!hireResumeUrl) {
			return
		}

		try {
			openExternalUrl(validateResumeFileUrl(hireResumeUrl), RESUME_FILE_ALLOWED_HOSTS)
		} catch (error) {
			console.warn('Blocked unsafe resume download URL', error)
		}
	}

	return (
		<PageWrapper>
			<TopBarRedesigned
				title="Candidate"
				onBack={() => {
					history.goBack()
				}}
				onAdditionalActionsButtonClick={onResumeDownload}
				additionalActionsIconType={AdditionalActionsIconType.download}
			/>
			<ResumeViewRedesigned
				name={application.name}
				file={application?.hireResumeUrl}
				onDownload={onResumeDownload}
			/>
		</PageWrapper>
	)
}
